import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import Clipboard from "@saleor/components/Clipboard";
import React from "react";
import { useIntl } from "react-intl";

import { BrandGroupFormData } from "../BrandGroupDetailsPage";

export interface BrandGroupDeepLinkProps {
  data: BrandGroupFormData;
}

const BrandGroupDeepLink: React.FC<BrandGroupDeepLinkProps> = props => {
  const { data } = props;
  const intl = useIntl();

  return (
    <Card>
      <CardTitle title="Deeplink Details" />
      <CardContent>
        <Clipboard
          label={intl.formatMessage({
            defaultMessage: "Brand Grouping ID",
            description: "brand grouping id"
          })}
          value={data.id}
          onGenerate={() => undefined}
        />
      </CardContent>
    </Card>
  );
};

export default BrandGroupDeepLink;
